const MeetingsIcon = ({ className = '', ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M15.9999 13V5L5.99997 5L5.99997 13C5.99997 13.5304 6.21068 14.0391 6.58575 14.4142C6.96082 14.7893 7.46952 15 7.99995 15H13.9999C14.5303 15 15.039 14.7893 15.4141 14.4142C15.7892 14.0391 15.9999 13.5304 15.9999 13ZM4.99998 3L19.9999 3C20.5303 3 21.039 3.21071 21.4141 3.58579C21.7891 3.96086 21.9998 4.46957 21.9998 5V8C21.9998 8.53043 21.7891 9.03914 21.4141 9.41421C21.039 9.78929 20.5303 10 19.9999 10H17.9999V13C17.9999 14.0609 17.5785 15.0783 16.8283 15.8284C16.0782 16.5786 15.0608 17 13.9999 17H7.99995C6.9391 17 5.92169 16.5786 5.17155 15.8284C4.42141 15.0783 3.99998 14.0609 3.99998 13L3.99998 4C3.99998 3.73478 4.10534 3.48043 4.29288 3.29289C4.48041 3.10536 4.73476 3 4.99998 3ZM17.9999 5V8H19.9999V5H17.9999ZM2 19H19.9999V21H2V19Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default MeetingsIcon;
